<form [formGroup]="formSignup" (ngSubmit)="handleSubmit()">
  <div class="registration-form__sections">
    <section class="registration-form__section">
      <h3 class="registration-form__section-header">Organisation</h3>
      <div class="registration-form__section-content">
        @if (accountTypeDisabled) {
          <mat-form-field>
            <mat-label>Account Type</mat-label>
            <input [value]="accountTypeValue" matInput disabled />
          </mat-form-field>
        } @else {
          <mat-radio-group class="registration-form__account-type--radio-group" formControlName="accountType">
            @for (type of accountTypes; track type) {
              <mat-radio-button class="registration-form__account-type--radio-entry" [value]="type.value">
                {{ type.key }}
              </mat-radio-button>
            }
          </mat-radio-group>
        }

        <mat-form-field>
          <mat-label>Organisation Type</mat-label>
          <mat-select title="Organisation Type" formControlName="orgType">
            <mat-option [value]="">--</mat-option>
            @for (type of orgTypes; track type) {
              <mat-option [value]="type.value">{{ type.key }} </mat-option>
            }
          </mat-select>
          <mat-error>Please choose a Organisation Type</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Organisation Phone Number</mat-label>
          <input matInput placeholder="Organisation Phone Number" formControlName="phoneNumber" />
          @if (getFormControl('phoneNumber').hasError('required')) {
            <mat-error>Please enter an Organisation Phone Number</mat-error>
          }
          @if (getFormControl('phoneNumber').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Organisation Email Address</mat-label>
          <mat-icon
            matTooltip="This email address is your organisation's generic/public address e.g. info@company.ie"
            matTooltipPosition="above"
            class="registration-form__help-icon"
          >
            info
          </mat-icon>
          <input matInput placeholder="Organisation mail Address" formControlName="emailAddress" />
          @if (getFormControl('emailAddress').hasError('required')) {
            <mat-error>Please enter an Organisation Email Address</mat-error>
          }
          @if (getFormControl('emailAddress').hasError('email')) {
            <mat-error>Please enter a valid email address</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Organisation Web Address</mat-label>
          <input matInput placeholder="Organisation Web Address" formControlName="webAddress" />
          @if (getFormControl('webAddress').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        @if (isPaAccountType) {
          <mat-form-field>
            <mat-label>ERAU Reference</mat-label>
            <input matInput placeholder="ERAU Reference" formControlName="erauReference" />
            @if (getFormControl('erauReference').hasError('required')) {
              <mat-error>Please enter valid ERAU Reference</mat-error>
            }
            @if (getFormControl('erauReference').hasError('pattern')) {
              <mat-error>This field contains invalid characters.</mat-error>
            }
          </mat-form-field>
        }

        <mat-form-field>
          <mat-label>Trademark Numbers</mat-label>
          <input matInput placeholder="Trademark Numbers" formControlName="trademarkNumbers" />
          @if (getFormControl('trademarkNumbers').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Tax Registration Number</mat-label>
          <input matInput placeholder="Tax Registration Number" formControlName="taxRegistrationNumber" />
          @if (getFormControl('taxRegistrationNumber').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        @if (!hideIsCroOptionalSection) {
          <mat-checkbox
            class="checkbox--pad-right checkbox--form-field-width checkbox-cell"
            formControlName="isCroOptional"
          >
            I don't have a CRO Number
          </mat-checkbox>
        }
        <mat-form-field 
          *ngIf="!isCroOptional"
          class="registration-form__form-field"
        >
          <mat-label>{{ croPlaceholder }}</mat-label>
          @if (!showSubmitButton) {
            <mat-icon
              matTooltip="Please enter your company number as registered by the Irish Companies Registration Office. If your organisation does not have a CRO number please tick 'I don’t have a CRO Number' and follow the instructions."
              matTooltipPosition="above"
              class="registration-form__help-icon"
            >
              info
            </mat-icon>
          }
          <input
            matInput
            [placeholder]="croPlaceholder"
            formControlName="croNumber" 
          />
          @if (getFormControl('croNumber').hasError('required')) {
            <mat-error>Please enter a valid CRO Number (6 - 8 digits)</mat-error>
          }
          @if (getFormControl('croNumber').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
         
        </mat-form-field>

        <mat-form-field *ngIf="!hideIsCroOptionalSection && isCroOptional">
          <mat-label>Organisation Registration Numbers</mat-label>
          <input matInput placeholder="Organisation Registration Number" formControlName="orgRegistrationNumber" />
          @if (getFormControl('orgRegistrationNumber').hasError('required')) {
            <mat-error>Please enter an Organisation Registration Number</mat-error>
          }
          @if (getFormControl('orgRegistrationNumber').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>
        <section class="registration-form__no-cro-section">
          @if (!hideIsCroOptionalSection && isCroOptional) {
            <p>
              If you do not have an Irish Companies Registration CRO number, please provide evidence that your application is from a legitimate organisation which has a need to register a Sender ID in the State.
              The more information you can provide now the more straightforward the application will be. We may need to contact you by email to seek further clarification.  (Comreg reserves the right to refuse any application that does not meet the criteria).
              To demonstrate that your organisation meets the criteria to register a Sender ID, please submit one or more of the following:
            </p>
            <ul>
              <li>
                A copy of your Certificate of Incorporation/Company Registration Certificate (or international equivalent),
              </li>
              <li>
                The trademark number or a digital copy of the trademark certificate for a trademark holder that holds a trademark that is enforceable in the State,
              </li>
              <li>
                A copy of your charity registration certificate or, details of your charity registered number from the Charities Regulator or evidence of registration as a non-profit making organisation in the State,
              </li>
              <li>
                Evidence that your organisation’s premises is in the State, e.g. organisations such as schools, clubs etc.
              </li>
              <li>
                A copy of your partnership/sole trader tax number in your name(s) or proof of your business or Irish Income tax registration. 
              </li>
            </ul>
            <p>
              If it is not possible to provide any of the above information but you wish to submit other evidence that yours is a legitimate organisation and has a need to register a Sender ID in the State, you may still do so by submitting other evidence.
            </p>
            <h4>Please upload all documentation by pressing the ‘Upload Documentation’ button. If you wish to submit more than one file, please create a zip file.</h4>

            <div class="registration-form__no-cro-section--upload-buttons-group">
              <button mat-raised-button class="button--secondary" type="button" (click)="handleDownloadButtonClick()">Download Instructions</button>
              <button mat-raised-button onclick="document.getElementById('file').click();return false;">Upload Documentation</button>
            </div>

            <div class="button-cell-row">
              <mat-error
                class="mat-mdc-form-field-error mat-mdc-form-field-bottom-align"
                [ngClass]="!fileError ? 'button-cell--row--file-name' : ''"
                [innerHtml]="fileMessage"
              ></mat-error>

              @if (getFormControl('fileName').hasError('required')) {
                <mat-error>Documentation is required</mat-error>
              }
            </div>
            <mat-form-field style="display: none">
              <input
                id="file"
                #fileUploadInput
                matInput
                [attr.type]="'file'"
                (change)="onFileChange($event.target.files)"
                [accept]="allowedExtensions"
                title="Select a file to upload"
              />
            </mat-form-field>
          }
        </section>
        </div>
    </section>

    <section class="registration-form__section">
      <h3 class="registration-form__section-header">Registered Address</h3>
      <div class="registration-form__section-content">
        <mat-form-field>
          <mat-label>Registered Organisation Name</mat-label>
          <input matInput placeholder="Registered Organisation Name" formControlName="organisationName" />
          @if (getFormControl('organisationName').hasError('required')) {
            <mat-error>Please enter a Registered Organisation Name</mat-error>
          }
          @if (getFormControl('organisationName').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Registered Address Line 1</mat-label>
          <input matInput placeholder="Registered Address Line 1" formControlName="registeredAddressLine1" />
          @if (getFormControl('registeredAddressLine1').hasError('required')) {
            <mat-error>Please enter a Registered Address Line 1</mat-error>
          }
          @if (getFormControl('registeredAddressLine1').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Registered Address Line 2</mat-label>
          <input matInput placeholder="Registered Address Line 2" formControlName="registeredAddressLine2" />
          @if (getFormControl('registeredAddressLine2').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Registered Address Line 3</mat-label>
          <input matInput placeholder="Registered Address Line 3" formControlName="registeredAddressLine3" />
          @if (getFormControl('registeredAddressLine3').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Registered Address Line 4</mat-label>
          <input matInput placeholder="Registered Address Line 4" formControlName="registeredAddressLine4" />
          @if (getFormControl('registeredAddressLine4').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Registered Address Country</mat-label>
          <mat-select title="Registered Address Country" formControlName="registeredAddressCountry">
            <mat-option value="">--</mat-option>
            @for (country of countries; track country) {
              <mat-option [value]="country.value">{{ country.key }} </mat-option>
            }
          </mat-select>
          @if (getFormControl('registeredAddressCountry').hasError('required')) {
            <mat-error>Please choose a Registered Address Country</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Registered Address Eircode/Postcode</mat-label>
          <input matInput placeholder="Registered Address Eircode/Postcode" formControlName="registeredAddressEircode" />
          @if (getFormControl('registeredAddressEircode').hasError('required')) {
            <mat-error>Please enter a Registered Address Eircode/Postcode</mat-error>
          }
          @if (getFormControl('registeredAddressEircode').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>
      </div>
    </section>

    @if (includeSingleContactEntry) {
      <section class="registration-form__section">
        <h3 class="registration-form__section-header">Contact Details</h3>
        <div class="registration-form__section-content">
          <mat-form-field>
            <mat-label>First Name</mat-label>
            <input matInput placeholder="First Name" formControlName="contactFirstName" />
            @if (getFormControl('contactFirstName').hasError('required')) {
              <mat-error>Please enter a First Name</mat-error>
            }
            @if (getFormControl('contactFirstName').hasError('pattern')) {
              <mat-error>This field contains invalid characters.</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>Last Name</mat-label>
            <input matInput placeholder="Last Name" formControlName="contactLastName" />
            @if (getFormControl('contactLastName').hasError('required')) {
              <mat-error>Please enter a Last Name</mat-error>
            }
            @if (getFormControl('contactLastName').hasError('pattern')) {
              <mat-error>This field contains invalid characters.</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>Contact Phone Number</mat-label>
            <input matInput placeholder="Contact Phone Number" formControlName="contactPhoneNumber" />
            @if (getFormControl('contactPhoneNumber').hasError('required')) {
              <mat-error>Please enter a Contact Phone Number</mat-error>
            }
            @if (getFormControl('contactPhoneNumber').hasError('pattern')) {
              <mat-error>This field contains invalid characters.</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>Contact Email Address</mat-label>
            <mat-icon
              matTooltip="This is the person we will contact to setup a Registry Account"
              matTooltipPosition="above"
              class="registration-form__help-icon"
            >
              info
            </mat-icon> 
            <input matInput placeholder="Contact Email Address" formControlName="contactEmailAddress" />
            @if (getFormControl('contactEmailAddress').hasError('required')) {
              <mat-error>Please enter a Contact Email Address</mat-error>
            }
            @if (getFormControl('contactEmailAddress').hasError('email')) {
              <mat-error>Please enter a valid email address</mat-error>
            }
          </mat-form-field>
        </div>
      </section>
    }

    <section class="registration-form__section">
      <h3 class="registration-form__section-header">Business Address</h3>
      <div class="registration-form__section-content">
        <mat-checkbox formControlName="useRegisteredAddressAsBusinessAddress"> Use the same as Registered Address </mat-checkbox>

        <mat-form-field>
          <mat-label>Business Address Line 1</mat-label>
          <input matInput placeholder="Business Address Line 1" formControlName="businessAddressLine1" />
          @if (getFormControl('businessAddressLine1').hasError('required')) {
            <mat-error>Please enter a Business Address Line 1</mat-error>
          }
          @if (getFormControl('businessAddressLine1').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Business Address Line 2</mat-label>
          <input matInput placeholder="Business Address Line 2" formControlName="businessAddressLine2" />
          @if (getFormControl('businessAddressLine2').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Business Address Line 3</mat-label>
          <input matInput placeholder="Business Address Line 3" formControlName="businessAddressLine3" />
          @if (getFormControl('businessAddressLine3').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Business Address Line 4</mat-label>
          <input matInput placeholder="Business Address Line 4" formControlName="businessAddressLine4" />
          @if (getFormControl('businessAddressLine4').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Business Address Country</mat-label>
          <mat-select title="Business Address Country" formControlName="businessAddressCountry">
            <mat-option value="">--</mat-option>
            @for (country of countries; track country) {
              <mat-option [value]="country.value">{{ country.value }}</mat-option>
            }
          </mat-select>
          @if (getFormControl('businessAddressCountry').hasError('required')) {
            <mat-error>Please choose a Business Address Country</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Business Address Eircode/Postcode</mat-label>
          <input matInput placeholder="Business Address Eircode" formControlName="businessAddressEircode" />
          @if (getFormControl('businessAddressEircode').hasError('required')) {
            <mat-error>Please enter a Business Address Eircode/Postcode</mat-error>
          }
          @if (getFormControl('businessAddressEircode').hasError('pattern')) {
            <mat-error>This field contains invalid characters.</mat-error>
          }
        </mat-form-field>
      </div>
    </section>
    @if (showPADownloadButton) {
      <section class="registration-form__section">
        <h3 class="registration-form__section-header">API File Download</h3>
        <div class="registration-form__section-content">
          Sender ID OPA Authorised List
          <button type="button" mat-raised-button class="button--secondary" (click)="handleDownloadAPIButtonClick('senderIDOPAAuthorised', 'json')">Json</button>
          <button type="button" mat-raised-button class="button--secondary" (click)="handleDownloadAPIButtonClick('senderIDOPAAuthorised', 'csv')">CSV</button>
        </div>
        <br>
        <div class="registration-form__section-content">
          Registered PA List
          <button type="button" mat-raised-button class="button--secondary" (click)="handleDownloadAPIButtonClick('registeredPA', 'json')">Json</button>
          <button type="button" mat-raised-button class="button--secondary" (click)="handleDownloadAPIButtonClick('registeredPA', 'csv')">CSV</button>
        </div>
        <br>
        <div class="registration-form__section-content">
          Registered Sender ID List
          <button type="button" mat-raised-button class="button--secondary" (click)="handleDownloadAPIButtonClick('registeredSenderID', 'json')">Json</button>
          <button type="button" mat-raised-button class="button--secondary" (click)="handleDownloadAPIButtonClick('registeredSenderID', 'csv')">CSV</button>
        </div>
      </section>
    }
    </div>

  @if (showSubmitButton) {
    <div class="registration-form__submit">
      <button mat-raised-button type="submit" [disabled]="maskService.isVisible.value">{{ submitButtonText }}</button>
    </div>
  }
</form>